function isLocal()
{
    return ['192.168.', '10.0.', '0.0.0.0'].some(host_part => global.location.hostname.startsWith(host_part))
}


module.exports = function()
{

    if (! global.location) return 'local';

    let APP_NAME = global.location.hostname.split('.')[0];

    if (global.location.hostname.indexOf('.') == -1 || isLocal()) {
        
        APP_NAME = global.location.pathname.split('/').filter(Boolean)[0];
    }
    return APP_NAME;
}



// WEBPACK FOOTER //
// ./src/helpers/app.js